import { GraphMutationBuilderPayload, createMutation } from '@camelot/server';

import { activityProps } from './dto/activity';
import { ActivityCreationPayloadInput } from './dto/activity-creation-payload-input';
import { ActivityModifierPayloadInput } from './dto/activity-modifier-payload-input';
import { companyProps } from './dto/company';
import { CompanyCreationPayloadInput } from './dto/company-creation-payload-input';
import { CompanyModifierPayloadInput } from './dto/company-modifier-payload-input';
import { departmentProps } from './dto/department';
import { DepartmentCreationPayloadInput } from './dto/department-creation-payload-input';
import { DepartmentModifierPayloadInput } from './dto/department-modifier-payload-input';

export function CREATE_COMPANY(
  companyCreationPayload: Partial<CompanyCreationPayloadInput>
): GraphMutationBuilderPayload {
  return createMutation('createNewCompany', {
    argument: 'companyCreationPayload',
    props: `
      ${companyProps.get('id')}
      ${companyProps.get('name')}
      ${companyProps.get('vatNumber')}
      ${companyProps.get('pictureDocumentId')}
      ${companyProps.get('pictureUrl')}
      ${companyProps.get('addressId')}
      ${companyProps.get('tenantId')}
    `,
    value: companyCreationPayload,
  });
}

export function UPDATE_COMPANY(
  companyModifierPayload: Partial<CompanyModifierPayloadInput>
): GraphMutationBuilderPayload {
  return createMutation('updateCompany', {
    argument: 'companyModifierPayload',
    props: `
      ${companyProps.get('id')}
      ${companyProps.get('name')}
      ${companyProps.get('vatNumber')}
      ${companyProps.get('pictureDocumentId')}
      ${companyProps.get('pictureUrl')}
      ${companyProps.get('addressId')}
      ${companyProps.get('tenantId')}
    `,
    value: companyModifierPayload,
  });
}

export function CREATE_DEPARTMENT(
  departmentCreationPayload: DepartmentCreationPayloadInput
): GraphMutationBuilderPayload {
  return createMutation('createNewDepartment', {
    argument: 'departmentCreationPayload',
    props: `
      ${departmentProps.get('id')}
      ${departmentProps.get('name')}
      ${departmentProps.get('pictureUrl')}
      ${departmentProps.get('tenantId')}
    `,
    value: departmentCreationPayload,
  });
}

export function UPDATE_DEPARTMENT(
  departmentModifierPayload: Partial<DepartmentModifierPayloadInput>
): GraphMutationBuilderPayload {
  return createMutation('updateDepartment', {
    argument: 'departmentModifierPayload',
    props: `
      ${departmentProps.get('id')}
      ${departmentProps.get('name')}
      ${departmentProps.get('pictureUrl')}
      ${departmentProps.get('tenantId')}
    `,
    value: departmentModifierPayload,
  });
}

export function CREATE_ACTIVITY(activityCreationPayload: ActivityCreationPayloadInput): GraphMutationBuilderPayload {
  return createMutation('createNewActivity', {
    argument: 'activityCreationPayload',
    props: `
      ${activityProps.get('id')}
      ${activityProps.get('code')}
      ${activityProps.get('enabled')}
    `,
    value: activityCreationPayload,
  });
}

export function UPDATE_ACTIVITY(
  activityModifierPayload: Partial<ActivityModifierPayloadInput>
): GraphMutationBuilderPayload {
  return createMutation('updateActivity', {
    argument: 'activityModifierPayload',
    props: `
      ${activityProps.get('id')}
      ${activityProps.get('code')}
      ${activityProps.get('enabled')}
    `,
    value: activityModifierPayload,
  });
}
